import React, { useContext } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import Brand from '../Brand/Brand';
import Navigation from '../Navigation/Navigation';
import { dashboardMenu, demoPages } from '../../menu';
import ThemeContext from '../../contexts/themeContext';
import useAsideTouch from '../../hooks/useAsideTouch';
import { userAuth } from '../../contexts/userContext';
import './sidebar.css';

const getAdminMenu = (isAdmin, pages = {}) => {
	const visiblePages = { ...pages };

	if (!isAdmin) {
		delete visiblePages.Manage_sadmin;
	}

	return visiblePages;
};

const Aside = () => {
	const { asideStatus, setAsideStatus } = useContext(ThemeContext);
	const { asideStyle } = useAsideTouch();
	const { token } = useContext(userAuth);

	return (
		<motion.aside
			style={asideStyle}
			initial={{ x: '-100%' }}
			animate={{ x: 0 }}
			transition={{ duration: 0.1, ease: 'easeInOut' }}
			className={classNames('aside', 'app-sidebar', {
				open: asideStatus,
				'aside-touch-bar': true,
				'aside-touch-bar-close': true,
				'aside-touch-bar-open': true,
			})}>
			<div className='aside-head'>
				<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
			</div>
			<div className='aside-body'>
				<p className='app-sidebar-section-label'>Workspace</p>
				<Navigation
					menu={dashboardMenu}
					id='aside-dashboard'
					asideStatus={asideStatus}
					setAsideStatus={setAsideStatus}
				/>
				<p className='app-sidebar-section-label'>Management</p>
				<Navigation
					menu={getAdminMenu(token?.is_super_admin, demoPages)}
					id='aside-demo-pages'
					asideStatus={asideStatus}
					setAsideStatus={setAsideStatus}
				/>
			</div>
		</motion.aside>
	);
};

export default Aside;
